import React  from "react";
import { useTranslation } from "react-i18next"; // ✅ Import translation hook
import HomeSection from "./../../sections/Home";
import Qute from "../../sections/Quote/Quote";
import CourseCarousel from "../../sections/CourseCarousel/CourseCarousel";
import Banner from "../../sections/Banner/Banner";
import CourseSectionHeader from "../../components/CourseSectionHeader/CourseSectionHeader";
import FAQ from "../../components/FAQ/FAQ";
import "./Home.css";
import EventCard from "../../components/EventCard/EventCard";

// ✅ Import both English and Russian program data
import { Programs as ProgramsEN } from "./../../data/programs";
import { Programs as ProgramsRU } from "./../../data/ruprograms";
import { generalFAQ, generalFAQRu } from "./../../data/faqMain";
import Partners from "../../sections/Partners/Partners";
import VideoGrid from "../../components/VideoGrid/VideoGrid";
import HowItWorks from "../../sections/HowItWorks/HowItWorks"; 

const Home: React.FC = () => {
  const { t, i18n } = useTranslation(); // ✅ Get current language
  const isRussian = i18n.language === "ru"; // ✅ Check if Russian is selected
  const Programs = isRussian ? ProgramsRU : ProgramsEN; // ✅ Use correct dataset
  const faqData = isRussian ? generalFAQRu : generalFAQ; // ✅ Use correct FAQ dataset 

  // ✅ Extract all events and include programId
  const allEvents = Programs.flatMap((program) =>
    program.events.map((event) => ({
      ...event,
      programId: program.id,
    }))
  );

  // ✅ Filter out events without a valid date and sort them by upcoming date
  const today = new Date();
  today.setHours(0, 0, 0, 0); // Normalize to only compare the date part
  
  const sortedEvents = allEvents
    .filter((event) => {
      const eventDate = new Date(event.dateOfEvent);
      eventDate.setHours(0, 0, 0, 0); // Normalize event date
      return eventDate >= today; // Only keep today or future events
    })
    .sort((a, b) => new Date(a.dateOfEvent).getTime() - new Date(b.dateOfEvent).getTime());
  

  return (
    <div style={styles.pageContainer}>
    

      <HomeSection />
      <Partners />
      <Qute />
      <CourseSectionHeader
        title={t("expanding_horizon")} // ✅ Translate title
        link={undefined}
        linkText={t("upcoming_events")} // ✅ Translate link text
      />
      <CourseCarousel />
     
      
      <CourseSectionHeader title={t("mark_your_calendar")} linkText={t("see_all")} />

      {/* ✅ Dynamically Load Events */}
      <div className="events-list-calendar">
  {sortedEvents.length > 1 ? ( // Ensure there are at least two future events
    sortedEvents.slice(1, 4).map((event) => ( // Skip first event, get next 3
      <EventCard
        key={event.id}
        eventType={event.eventType}
        image={event.image}
        master={event.eventMaster}
        date={`${event.date} ${t("at")} ${event.time}`} 
        title={event.name}
        description={event.description || t("no_description")} // ✅ Translatable
        learnMoreLink={`/program/${event.programId}/event/${event.id}`}
        speakersLink={``}
        locationLink={event.locationLink}
        location={event.location}
      />
    ))
  ) : (
    <p style={{ color: "#fff", textAlign: "center" }}>
      {t("no_upcoming_events")} {/* ✅ Translate fallback text */}
    </p>
  )}
</div>

<HowItWorks/>
<VideoGrid />
      <div>
        <Banner
          title={t("expand_teen_title")}
          description={t("expand_teen_description")}
          buttonText={t("learn_more")}
        />
      </div>

      {/* ✅ Dynamically switch FAQ data */}
      <FAQ data={faqData} />
    </div>
  );
};

const styles = {
  pageContainer: {
    width: "100%",
    margin: 0,
    padding: 0,
    overflowX: "hidden", // Prevents any horizontal scrolling if content overflows
  } as React.CSSProperties,
};

export default Home;
